<template>
    <div class="recipe">
        <div class="recipe__top">
            <div class="recipe__top__inner">
                <div class="recipe__text">
                    <h1 class="recipe__name">{{ recipe.name }}</h1>
                    <div class="recipe__details">
                        <p class="align-center">
                            <span class="text--ucase text--small">Added:</span>
                            {{ formattedDate(recipe.origDate) }}
                            <span
                                v-if="recipe.lastUpdated"
                            >
                                &nbsp;|
                                <span class="text--ucase text--small">Updated:</span>
                                {{ formattedDate(recipe.lastUpdated) }}
                            </span>
                            <router-link
                                :to="{ name: 'recipeEdit', params: { id: recipe.urlId }}"
                                class="button"
                            >Edit</router-link>
                            <br />
                            <span class="text--ucase text--small">Added By:</span>
                            {{ author }}
                        </p>
                        <div class="recipe__numbers">
                            <ul class="info-list">
                                <li class="info-list__item">
                                    <strong>{{ totalTimeCalc }}</strong>
                                    <br />
                                    <small class="text--ucase">Minutes</small>
                                </li>
                                <li class="info-list__item">
                                    <!--{{ recipe.ingredients.length }}-->
                                    <strong>{{ getIngredientsLength(recipe.sectionIds) }}</strong>
                                    <br />
                                    <small class="text--ucase">Ingredients</small>
                                </li>
                                <li class="info-list__item">
                                    <strong>{{ recipe.servings }}</strong>
                                    <br />
                                    <small class="text--ucase">Servings</small>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="recipe__image">
                    <!--<img :src="`${imageUrl}`" :alt="`${recipe.name}`" v-if="recipe.imageName !== ''">-->
                    <img :src="recipe.imageUrl" :alt="recipe.name" />
                </div>
            </div>
        </div>
        <div class="recipe__information">
            <ul class="list list--unbulleted recipe-nav">
                <li class="recipe-nav__item" id="show-ingredients">Ingredients</li>
                <li class="recipe-nav__item" id="show-directions">Directions</li>
                <li class="recipe-nav__item" id="show-details" v-if="showRecipeDetails">Details</li>
            </ul>
            <div class="recipe__content">
                <div class="ingredients">
                    <h2>Ingredients</h2>
                    <div
                        class="ingredients__section"
                        id="ingredients"
                        v-for="section in recipeSections"
                        :key="section.id"
                    >
                        <h3 v-if="section.sectionTitle !== ''">{{ section.sectionTitle }}</h3>
                        <ul class="list list--bulleted ingredients__list">
                            <li
                                class="ingredient__item"
                                v-for="ingredient in section.ingredients"
                                :key="ingredient"
                            >
                                <span
                                    v-if="ingredients[ingredient].amount !== ''"
                                >{{ ingredients[ingredient].amount + ' ' }}</span>
                                <span
                                    class="ingredient__name"
                                    v-if="ingredients[ingredient].name !== ''"
                                >{{ ingredients[ingredient].name }}</span>
                                <span
                                    class="ingredient.note"
                                    v-if="ingredients[ingredient].note != ''"
                                >{{ ' ' + ingredients[ingredient].note }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="directions" id="directions">
                    <h2>Directions</h2>
                    <div
                        class="directions__section"
                        v-for="section in recipeSections"
                        :key="section.id"
                    >
                        <h3 v-if="section.sectionTitle !== ''">{{ section.sectionTitle }}</h3>
                        <ol class="directions__list">
                            <li
                                class="directions__item"
                                v-for="direction in section.directions"
                                :key="direction"
                            >{{ directions[direction].direction }} {{ directions[direction].note }}</li>
                        </ol>
                    </div>
                </div>
                <div class="details" id="details" v-if="showRecipeDetails">
                    <div
                        class="details__section"
                        v-for="section in recipe.details"
                        :key="section.id"
                    >{{ section }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import firebase from "firebase";

export default {
    props: {
        recipe: Object
    },

    data() {
        return {
            totalTime: 0,
            showRecipeDetails: false,
            imageUrl: ""
        };
    },

    mounted() {
        console.log(this.recipe);
        console.log(this.recipeSections);

        if (this.recipe.imageName !== "") {
            this.getImage();
        }
    },

    computed: {
        ...mapGetters(["sections", "ingredients", "directions", "getUsers"]),
        totalTimeCalc() {
            return (
                parseInt(this.recipe.prepTime) + parseInt(this.recipe.cookTime)
            );
        },
        recipeSections() {
            let sectionIds = this.recipe.sectionIds; // [ 0, 1 ]
            let sectionArray = [];

            sectionIds.forEach(section => {
                sectionArray.push(this.sections[section]);
            });

            return sectionArray;
        },
        author() {
            let authorId = this.recipe.author;
            return this.getUsers[authorId].name;
        }
    },

    methods: {
        getImage() {
            let imageName = this.recipe.imageName;
            let self = this;
            //console.log(imageName);
            let storageRef = firebase.storage().ref();
            let pathReference = storageRef.child(imageName);
            //console.log(storageRef, pathReference);

            pathReference.getDownloadURL().then(function(url) {
                console.log(url);
                self.imageUrl = url;
            });
        },
        getIngredientsLength(sectionNumbers) {
            let ingredientsLength = 0;

            sectionNumbers.forEach(section => {
                ingredientsLength += this.sections[section].ingredients.length;
            });

            return ingredientsLength;
        },
        /*getSectionIngredients(recipeSection) {
						let ingredientArray = [];
						console.log(recipeSection);
						//this.recipeSections.push()
						this.sections[recipeSection].ingredients.forEach(ingredient => {
								ingredientArray.push(this.ingredients[ingredient]);
						});

						return ingredientArray;
				},*/
        toggleEditStatus() {
            this.$emit("toggleEditStatus");
        },
        formattedDate(date) {
            let newDate = new Date(date);
            return newDate.toLocaleDateString({
                month: "2-digit",
                day: "2-digit",
                year: "numeric"
            });
        }
    }
};
</script>

<style lang="scss"></style>